// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal___3D4YV","modalContent":"modalContent___2rkr9","title":"title___8jGrg","qrCode":"qrCode___1Qm_c","serviceText":"serviceText___379N0"};